import { prodAuthApi } from './auth-api.prod'

export const authApi = prodAuthApi

export type {
  AuthApi,
  GetMeResult,
  LogoutResult,
  RequestCodeResult,
  VerifyOtpResult,
} from './auth-api.types'
